<template>
  <div class="appContainer login">
    <div class="login-container">
      <v-row class="mt-4 banner">
        <img v-bind:src="m_event.banner_img" alt="" class="img-banner" />
      </v-row>

      <v-row class="mt-4 widget-login" no-gutters="">
        <v-col class="col-left" sm="12" md="6" cols="12" lg="6">
          <h2>
            {{ $t('login-page.title-register', { split: '/' }) }}
          </h2>
          <!-- :to="pathDefault + '/register'" -->
          <div class="button-register">
            <router-link
              v-if="registrationPeriodStatus"
              tag="button"
              class="wrap-btn"
              :to="{
                name: 'register-applicant',
                query: query
              }"
              ><v-btn class="login-btn" color="#E8320D" outlined
                >{{
                  $t('login-page.btn-register', {
                    split: '/'
                  })
                }}
              </v-btn></router-link
            >

            <h3 v-else>
              {{
                $t('login-page.title-register-expried', {
                  split: '/'
                })
              }}
            </h3>
          </div>
        </v-col>

        <v-col class="col-right" sm="12" md="6" cols="12" lg="6">
          <div class="wrap-login">
            <h2>
              {{ $t('login-page.title-login', { split: '/' }) }}
            </h2>

            <v-form
              class="form mt-3"
              ref="form"
              v-model="valid"
              :v-bind="true"
              v-on:submit.prevent="handleSubmit"
            >
              <div class="item">
                <label>{{
                  $t('login-page.label-email', { split: '/' }) +
                  ' (' +
                  $t('login-page.email-note', { split: '/' }) +
                  ')'
                }}</label>
                <v-text-field
                  v-model.trim="$v.email.$model"
                  outlined
                  dense
                  class="mt-1 input-login"
                  hide-details="true"
                  @keyup.enter="handleSubmit"
                ></v-text-field>
                <div
                  class="error-input"
                  v-if="
                    $v.email.$invalid && $v.email.$dirty && !$v.email.required
                  "
                >
                  {{ $t('login-page.validate.email-required', { split: '/' }) }}
                </div>

                <div
                  class="error-input"
                  v-if="$v.email.$invalid && $v.email.$dirty && !$v.email.email"
                >
                  {{ $t('login-page.validate.email-invalid', { split: '/' }) }}
                </div>
              </div>

              <div class="item mt-4">
                <label>{{
                  $t('login-page.label-password', {
                    split: '/'
                  })
                }}</label>
                <v-text-field
                  v-model.trim="$v.password.$model"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  maxlength="30"
                  @click:append="show1 = !show1"
                  outlined
                  dense
                  @keydown.space.prevent
                  class="mt-1 input-login"
                  hide-details="true"
                  @keyup.enter="handleSubmit"
                ></v-text-field>

                <div
                  class="error-input"
                  v-if="
                    $v.password.$invalid &&
                    $v.password.$dirty &&
                    !$v.password.required
                  "
                >
                  {{
                    $t('login-page.validate.password-required', { split: '/' })
                  }}
                </div>
                <div
                  class="error-input"
                  v-if="
                    $v.password.$invalid &&
                    $v.password.$dirty &&
                    !$v.password.minLength
                  "
                >
                  {{
                    $t('login-page.validate.password-minLength', { split: '/' })
                  }}
                </div>

                <div
                  class="error-input"
                  v-if="
                    $v.password.$invalid &&
                    $v.password.$dirty &&
                    !$v.password.maxLength
                  "
                >
                  {{
                    $t('login-page.validate.password-maxLength', { split: '/' })
                  }}
                </div>
              </div>

              <div class="item text-center mt-4">
                <v-btn
                  class="login-btn text-white"
                  color="#E8320D"
                  v-on:click="handleSubmit"
                  >{{
                    $t('login-page.btn-login', {
                      split: '/'
                    })
                  }}</v-btn
                >
              </div>
            </v-form>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="px-0">
          <div class="row pl-3">
            <h4
              class="left-border"
              v-html="
                $t('top-page.info.title', { split: '/' }) +
                ': ' +
                m_event.event_name
              "
            ></h4>
          </div>

          <table class="table-homepage">
            <tbody>
              <tr>
                <td>
                  {{
                    $t('top-page.text-field.event-period', {
                      split: '/'
                    })
                  }}
                </td>
                <td>
                  {{ this.displayEventPeriod() + timezoneFormat() }}
                </td>
              </tr>
              <tr>
                <td>
                  {{
                    $t('top-page.text-field.event-address', {
                      split: '/'
                    })
                  }}
                </td>
                <td>{{ m_event.location_address }}</td>
              </tr>

              <tr>
                <td>{{ $t('top-page.text-field.map') }}</td>
                <td>
                  <a :href="m_event.location_map_url" target="_blank">{{
                    m_event.location_map_url
                  }}</a>
                </td>
              </tr>
              <tr>
                <td>
                  {{
                    $t('top-page.text-field.event-content', {
                      split: '/'
                    })
                  }}
                </td>
                <td>
                  <div
                    v-html="m_event.event_content"
                    class="div-textarea html-content"
                  ></div>
                </td>
              </tr>
              <tr
                v-if="
                  m_event !== null &&
                  m_event.applicant_document !== null &&
                  m_event.applicant_document !== ''
                "
              >
                <td>
                  {{
                    $t('top-page.text-field.company-document', {
                      split: '/'
                    })
                  }}
                </td>
                <td>
                  <a :href="m_event.applicant_document" target="_blank">{{
                    $t('top-page.document-download', {
                      split: '/'
                    })
                  }}</a>
                </td>
              </tr>
            </tbody>
          </table>

          <hr class="hr-line-homepage" v-if="checkDisplayHr()" />

          <table class="table-homepage2">
            <tbody>
              <tr
                v-if="
                  m_event !== null && m_event.organizer_name_display == DISPLAY
                "
              >
                <td>
                  {{
                    $t('top-page.text-field.organize-name', {
                      split: '/'
                    })
                  }}
                </td>
                <td class="td-right">
                  {{ m_event.organizer_name }}
                </td>
              </tr>
              <tr
                v-if="m_event !== null && m_event.cooperator_display == DISPLAY"
              >
                <td>
                  {{
                    $t('top-page.text-field.cooperator', {
                      split: '/'
                    })
                  }}
                </td>
                <td class="td-right">
                  {{ m_event.cooperator }}
                </td>
              </tr>

              <tr v-if="m_event !== null && m_event.sponsor_display == DISPLAY">
                <td>
                  {{
                    $t('top-page.text-field.sponsor', {
                      split: '/'
                    })
                  }}
                </td>
                <td class="td-right">{{ m_event.sponsor }}</td>
              </tr>
              <tr
                v-if="m_event !== null && m_event.operator_display == DISPLAY"
              >
                <td>
                  {{
                    $t('top-page.text-field.operator', {
                      split: '/'
                    })
                  }}
                </td>
                <td class="td-right">
                  {{ m_event.operator }}
                </td>
              </tr>
            </tbody>
          </table>

          <hr class="hr-line-homepage" v-if="checkDisplayContactTo()" />

          <table class="table-homepage">
            <tbody>
              <tr>
                <td v-if="checkDisplayContactTo()">
                  {{
                    $t('top-page.text-field.contact-to', {
                      split: '/'
                    })
                  }}
                </td>
                <td class="widget-button-info">
                  <div
                    class="mr-2"
                    v-if="
                      m_event !== null &&
                      m_event.contact_to_display === DISPLAY_TAG
                    "
                  >
                    <v-btn icon color="#e8320e">
                      <v-icon>mdi-account</v-icon> </v-btn
                    >{{ m_event.contact_to }}
                  </div>

                  <div
                    class="mr-2"
                    v-if="
                      m_event !== null &&
                      m_event.contact_mail_display === DISPLAY_TAG
                    "
                  >
                    <v-btn
                      icon
                      color="#e8320e"
                      :href="`mailto:${m_event.contact_mail}`"
                    >
                      <v-icon>mdi-email</v-icon> </v-btn
                    ><a :href="`mailto:${m_event.contact_mail}`">{{
                      m_event.contact_mail
                    }}</a>
                  </div>

                  <div
                    class="mr-2"
                    v-if="
                      m_event !== null &&
                      m_event.contact_phone_display === DISPLAY_TAG
                    "
                  >
                    <v-btn
                      icon
                      color="#e8320e"
                      :href="`tel:${m_event.contact_phone}`"
                    >
                      <v-icon>mdi-phone</v-icon> </v-btn
                    ><a :href="`tel:${m_event.contact_phone}`">{{
                      m_event.contact_phone
                    }}</a>
                  </div>

                  <div
                    class="mr-2"
                    v-if="
                      m_event !== null &&
                      m_event.contact_address_display === DISPLAY_TAG
                    "
                  >
                    <v-btn icon color="#e8320e">
                      <v-icon>mdi-map</v-icon> </v-btn
                    >{{ m_event.contact_address }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength
} from 'vuelidate/lib/validators';
import './login.scss';
import { Trans } from '@/plugins/translation.js';
import { mapGetters } from 'vuex';
import { UN_DISPLAY_TAG, DISPLAY_TAG } from '@/common/constants';
// import { getEventFromLS } from '@/common/index';

export default {
  name: 'login',
  components: {},
  data: () => ({
    imgBanner:
      'https://2.bp.blogspot.com/--MiYgDdq7aU/Vpi0mKQ0cyI/AAAAAAAARVg/JONJuFjwLiM/s1600/Hinh-anh-dep-google-tim-kiem-nhieu-%25282%2529.jpg',
    valid: true,
    email: '',
    password: '',
    show1: false,

    items: [
      { key: 'jp-en', title: '日本語/Eng' },
      { key: 'vi', title: 'Tiếng Việt' }
    ],
    canRegister: false,

    urlCode: '',
    query: {}
  }),

  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(30)
    }
  },

  methods: {
    changeLanguage(lang) {
      this.$store.dispatch('changeLanguage', { lang });
      Trans.changeLanguage(lang);
    },

    checkRegisterToHideRegisterButton() {
      if (this.$route.query !== null) {
        if (
          typeof this.urlRegisterCode !== 'undefined' &&
          this.urlRegisterCode !== ''
        ) {
          if (this.m_event) {
            const { event_day_register_url_code } = this.m_event;
            if (event_day_register_url_code === this.urlRegisterCode) {
              this.$store.dispatch('setRegistrationPeriodStatus', false);
            }
          }
        }
      }
    },

    handleSubmit() {
      this.$v.$touch();
      const data = {
        mail_address: this.email,
        password: this.password,
        event_id: this.$store.state.checkEvent.event_id
      };

      if (!this.$v.$error) {
        this.$store.dispatch('clearRegisterData');
        this.$store.dispatch('login', { data }).then((res) => {
          if (res === true) {
            this.checkRegisterToHideRegisterButton();
            this.$router.push(this.pathDefault + '/me', () => {});
          }
        });
      }
    },

    displayEventPeriod() {
      let stringDateTime = '';
      if (this.m_event !== null) {
        stringDateTime =
          this.convertDateAndTime(
            this.m_event.event_period_from_event_time_zone
          ) +
          ' ~ ' +
          this.convertDateAndTime(this.m_event.event_period_to_event_time_zone);
      }

      return stringDateTime;
    },
    timezoneFormat: function () {
      const arr = this.c_time_zone.filter(
        (ele) => ele.id === this.m_event.time_zone
      );

      if (arr.length > 0) {
        return '(' + arr[0].name_convert + ')';
      } else return null;
    },
    checkDisplayHr() {
      if (this.m_event !== null) {
        const {
          organizer_name_display,
          cooperator_display,
          sponsor_display,
          operator_display
        } = this.m_event;

        if (
          sponsor_display === this.UN_DISPLAY_TAG &&
          operator_display === this.UN_DISPLAY_TAG &&
          organizer_name_display === this.UN_DISPLAY_TAG &&
          cooperator_display === this.UN_DISPLAY_TAG
        ) {
          return false;
        }
      }
      return true;
    },

    checkDisplayContactTo() {
      if (this.m_event !== null) {
        const {
          contact_to_display,
          contact_mail_display,
          contact_phone_display,
          contact_address_display
        } = this.m_event;

        if (
          contact_to_display === this.UN_DISPLAY_TAG &&
          contact_mail_display === this.UN_DISPLAY_TAG &&
          contact_phone_display === this.UN_DISPLAY_TAG &&
          contact_address_display === this.UN_DISPLAY_TAG
        ) {
          return false;
        }
      }
      return true;
    }
  },

  watch: {
    'checkAuth.isAuthenticated': function (val) {
      if (val === true) {
        this.$router.push(this.pathDefault + '/me', () => {});
      }
    },
    '$route.query': function (val) {
      if (val !== null) {
        const { event_day_register_url_code } = val;

        if (typeof event_day_register_url_code !== 'undefined') {
          this.urlRegisterCode = event_day_register_url_code;
          if (this.m_event) {
            const { event_day_register_url_code } = this.m_event;

            if (
              this.urlRegisterCode !== '' &&
              event_day_register_url_code !== this.urlRegisterCode
            ) {
              this.$router.push(this.pathDefault);
            } else {
              this.$store.dispatch('setRegistrationPeriodStatus', true);
              this.urlCode = event_day_register_url_code;
              this.query = {
                event_day_register_url_code: this.urlCode
              };
            }
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      registrationPeriodStatus: 'getRegistrationPeriodStatus',
      m_event: 'getEventData',
      status: 'getStatusCheckEvent',
      checkAuth: 'getStatusCheckAuth'
    })
  },

  created() {
    this.DISPLAY_TAG = DISPLAY_TAG;
    this.UN_DISPLAY_TAG = UN_DISPLAY_TAG;

    if (this.$route.query !== null) {
      const { event_day_register_url_code } = this.$route.query;

      if (typeof event_day_register_url_code !== 'undefined') {
        this.urlRegisterCode = event_day_register_url_code;
        if (this.m_event) {
          const { event_day_register_url_code } = this.m_event;

          if (event_day_register_url_code !== this.urlRegisterCode) {
            this.$router.push(this.pathDefault, () => {});
          } else {
            this.$store.dispatch('setRegistrationPeriodStatus', true);
            this.urlCode = event_day_register_url_code;
            this.query = {
              event_day_register_url_code: this.urlCode
            };
          }
        }
      }
    }
  }
};
</script>
<style lang="scss">
@media only screen and (max-width: 450px) {
  .div-texarea {
    max-width: 100% !important;
  }
  .html-content {
    max-width: 100% !important;
  }
}
</style>
